/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'licensing';
const componentName = 'licensing-page-status-card';
const prefix = `${moduleName}.${componentName}`;

export const connectivityStatusLabel = `${prefix}.connectivityStatusLabel`;
export const connectedLabel = `${prefix}.connectedLabel`;
export const disconnectedLabel = `${prefix}.disconnectedLabel`;
export const lastRefreshLabel = `${prefix}.lastRefreshLabel`;
export const clusterNameLabel = `${prefix}.clusterNameLabel`;
export const registerButtonLabel = `${prefix}.registerButtonLabel`;
export const connectionErrorMessage = `${prefix}.connectionErrorMessage`;
export const cloudLicensingLabel = `${prefix}.cloudLicensingLabel`;
export const isDeregisterControllerMessage = `${prefix}.isDeregisterControllerMessage`;
export const disconnectFromCloudServiceLabel = `${prefix}.disconnectFromCloudServiceLabel`;
export const portalUrlLabel = `${prefix}.portalUrlLabel`;
export const completeRegistrationLabel = `${prefix}.completeRegistrationLabel`;
export const disconnectFromOnPremMessage = `${prefix}.disconnectFromOnPremMessage`;
export const disconnectOnPremLicensingLabel = `${prefix}.disconnectOnPremLicensingLabel`;
export const connectOnPremLabel = `${prefix}.connectOnPremLabel`;
export const onPremLicensingServiceUrlLabel = `${prefix}.onPremLicensingServiceUrlLabel`;
export const defaultErrorMessage = `${prefix}.defaultErrorMessage`;
export const cancelRegistrationLabel = `${prefix}.cancelRegistrationLabel`;
export const cancelRegistrationMessage = `${prefix}.cancelRegistrationMessage`;

export const ENGLISH = {
    [connectivityStatusLabel]: 'Connectivity Status',
    [connectedLabel]: 'Connected',
    [disconnectedLabel]: 'Disconnected',
    [lastRefreshLabel]: 'Last Refresh',
    [registerButtonLabel]: 'Register Controller',
    [clusterNameLabel]: 'Cluster Name',
    [connectionErrorMessage]: 'A connection error has occurred, Controller will auto-retry in 10 seconds.',
    [cloudLicensingLabel]: 'Cloud Licensing',
    [isDeregisterControllerMessage]: 'Are you sure you want to Deregister this Controller?',
    [disconnectFromCloudServiceLabel]: 'Disconnect from Cloud Licensing',
    [portalUrlLabel]: 'Portal URL',
    [completeRegistrationLabel]: 'Complete Registration',
    [disconnectFromOnPremMessage]: 'Are you sure you want to disconnect from On-Prem Licensing Service?',
    [disconnectOnPremLicensingLabel]: 'Disconnect On-Prem Licensing',
    [connectOnPremLabel]: 'Connect On-Prem Licensing Service',
    [onPremLicensingServiceUrlLabel]: 'On-prem License Hub URL',
    [defaultErrorMessage]: 'Something went wrong. Please try again.',
    [cancelRegistrationLabel]: 'Cancel Registration',
    [cancelRegistrationMessage]: 'This will cancel the in-progress registration and disconnect from Cloud Services.',
};
